enum DimensionUnitsEnum {
    INCHES = 1,
    FEET = 2,
    METERS = 3,
    CENTIMETERS = 4,
    MILLIMETERS = 5,
    YARDS = 6,
}

export default DimensionUnitsEnum;
